import Flight, { FlightRiskAssessmentLevel } from "./flight"

export type Organization = {
    id: string
    name: string,
    role: "admin" | "pilot",
    riskAssessment: {
        enabled: boolean,
        shouldFillAllScoreFields: boolean,
        flightCategories: (Flight["flightCategory"])[]
        disableFplFlightCategories: (Flight["flightCategory"])[]
        levels: FlightRiskAssessmentLevel[]
        needSoloSupCertificate: boolean
    },
    //Post-flight student training record — per-org opt-in, missing means off
    trainingRecord?: {
        enabled: boolean,
    },
    //On-site print server (e.g. a Raspberry Pi running CUPS) — per-org opt-in, missing means off.
    //When enabled, signed docs can be queued for direct printing from the app.
    printServer?: {
        enabled: boolean,
    },
    isLatArmInWbPointUp: boolean,
    //IFR flight creation is an org-level opt-in (default off) — gates the VFR/IFR chooser
    ifrEnabled?: boolean,
    externalWalletPass?: {
        fieldDisplayName: string,
        formatDisplayError: string,
        formatRegex: string,
        passTypeId: string,
    },
    billing: {
        type: "prepaid" | "invoice"
        credits: number,
        canFileFpl: boolean,
        canCreateBriefingPack: boolean,
    },
    showOnlyAirfieldId?: string,
    airfieldSlots: {
        airfieldId: string,
        airfieldName: string,
    }[],
}

export function isAnonymousOrganization(org: Organization): boolean {
    return org.id.startsWith("anon_")
}

export function createTempAnonymousOrganizationForAirfield(uid: string, airfieldId: string): Organization {
   return {
        id: "anon_"+uid,
        name: "",
        role: "admin" as "admin" | "pilot",
        riskAssessment: {
            enabled: false,
            shouldFillAllScoreFields: false,
            flightCategories: [],
            disableFplFlightCategories: [],
            levels: [],
            needSoloSupCertificate: false
        },
        isLatArmInWbPointUp: false,
        airfieldSlots:[],
        showOnlyAirfieldId: airfieldId,
        billing: {
            type: "prepaid" as "prepaid" | "invoice",
            credits: 0,
            canFileFpl: false,
            canCreateBriefingPack: false
        }                
    }
}